import i18n from '@/lang';
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
// 工单状态映射表
export var orderStatusMapping = new Map([['0_0', i18n.tc("61")], ['1_0', i18n.tc("62")], ['2_0', i18n.tc("63")], ['3_0', i18n.tc("63")], ['4_0', i18n.tc("63")], ['5_0', i18n.tc("64")], ['5_1', i18n.tc("65")], ['6_0', i18n.tc("66")], ['6_1', i18n.tc("66")]]);

// 工单状态列表
export var orderStatusList = [{
  value: 0,
  name: i18n.tc("67")
}, {
  value: 1,
  name: i18n.tc("62")
}, {
  value: 2,
  name: i18n.tc("63")
}, {
  value: 3,
  name: i18n.tc("64")
}, {
  value: 4,
  name: i18n.tc("65")
}, {
  value: 5,
  name: i18n.tc("66")
}];

// 工单状态对应色值映射表
export var statusColorMapping = {
  0: '#FFB84D',
  1: '#FFB84D',
  2: '#FFB84D',
  3: '#5ED298',
  4: '#5ED298',
  5: '#6CAFF5',
  6: '#a3a5a7'
};

// 工单相关度列表
export var relevanceList = [{
  value: 1,
  name: i18n.tc("68")
}, {
  value: 2,
  name: i18n.tc("70")
}, {
  value: 3,
  name: i18n.tc("71")
}];

// 工单列表排序
export var orderSortList = [{
  value: '1',
  name: i18n.tc("72")
}, {
  value: '4',
  name: i18n.tc("73")
}, {
  value: '3',
  name: i18n.tc("74")
}, {
  value: '6',
  name: i18n.tc("75")
}, {
  value: '2',
  name: i18n.tc("76")
}, {
  value: '5',
  name: i18n.tc("77")
}];

// 工单回执状态
export var receiptStateList = [{
  value: '0',
  name: i18n.tc("78")
}, {
  value: '1',
  name: i18n.tc("79")
}];

// 工单收款状态
export var settlementStateList = [{
  value: '0',
  name: i18n.tc("80")
}, {
  value: '1',
  name: i18n.tc("81")
}];

// 工单回执状态
export var evaluateStateList = [{
  value: '0',
  name: i18n.tc("82")
}, {
  value: '1',
  name: i18n.tc("65")
}];

// 工单来源
export var orderSourceList = [{
  value: '1',
  name: i18n.tc("36")
}, {
  value: '2',
  name: i18n.tc("83")
}, {
  value: '3',
  name: i18n.tc("84")
}, {
  value: '4',
  name: i18n.tc("85")
}];

// 工单超时状态
export var timeoutStateList = [{
  value: '1',
  name: i18n.tc("86")
}, {
  value: '0',
  name: i18n.tc("87")
}];

// 工单异常
export var abnormalStateList = [{
  value: '1',
  name: i18n.tc("86")
}, {
  value: '0',
  name: i18n.tc("87")
}];

// 工单优先级列表
export var priorityList = [{
  value: '1',
  name: i18n.tc("88")
}, {
  value: '2',
  name: i18n.tc("89")
}, {
  value: '3',
  name: i18n.tc("90")
}];

// 超时类型
export var orderDueStateList = [{
  name: i18n.tc("91"),
  value: '1'
}, {
  name: i18n.tc("92"),
  value: '2'
}, {
  name: i18n.tc("93"),
  value: '3'
}, {
  name: i18n.tc("94"),
  value: '4'
}, {
  name: i18n.tc("149"),
  value: '5'
}, {
  name: i18n.tc("150"),
  value: '6'
}, {
  name: i18n.tc("151"),
  value: '7'
}, {
  name: i18n.tc("152"),
  value: '8'
}, {
  name: i18n.tc("153"),
  value: '9'
}];

// 工单优先级映射表
export var priorityMapping = {
  1: i18n.tc("88"),
  2: i18n.tc("89"),
  3: i18n.tc("90")
};
export var titleRuleSystemFieldList = [{
  key: 'fk_t_ep_service',
  value: i18n.tc("69"),
  obj: 'service_name'
}, {
  key: 'custom_apply_time',
  value: i18n.tc("154"),
  obj: 'custom_apply_time'
}, {
  key: 'custom_name',
  value: i18n.tc("155"),
  obj: 'custom_name'
}, {
  key: 'link_name',
  value: i18n.tc("156"),
  obj: 'link_name'
}, {
  key: 'link_phone',
  value: i18n.tc("157"),
  obj: 'custom_phone'
}, {
  key: 'custom_enterprise_name',
  value: i18n.tc("158"),
  obj: 'custom_enterprise_name'
}, {
  key: 'custom_production',
  value: i18n.tc("159"),
  obj: 'custom_production'
}, {
  key: 'detail_desc',
  value: i18n.tc("160"),
  obj: 'detail_desc'
}];

// 服务收款类别
export var payTypeList = [{
  name: i18n.tc("161"),
  value: '1'
}, {
  name: i18n.tc("162"),
  value: '2'
}, {
  name: i18n.tc("163"),
  value: '3'
}, {
  name: i18n.tc("164"),
  value: '4'
}, {
  name: i18n.tc("165"),
  value: '5'
}];
export var payTypeMapping = {
  1: i18n.tc("161"),
  2: i18n.tc("162"),
  3: i18n.tc("163"),
  4: i18n.tc("164"),
  5: i18n.tc("165")
};